<div class="suporte-geral-edit">
  <header class="mb-4">
    <h2 class="h2-edit">Suporte - {{ actionLabel }}</h2>
  </header>
  <ng-container [ngSwitch]="type" *ngIf="type == 'create' || data?.id">
    <app-view-form *ngSwitchCase="'view'" [formData]="formData" [data]="data"></app-view-form>
    
  </ng-container>
</div>
<app-loading [loader]="isLoading"></app-loading>

